// MA19 합배송스케쥴 상수 (TM-4166). 서버(moms-be ManagePairOrderScheduleService·PairOrderScheduleController)와 맞춰야 하는 값이 섞여 있다.

/** 2.0 메뉴코드. 1.0 MA10 은 iframe 으로 남는다. */
export const PAIR_ORDER_SCHEDULE_MENU_CODE = 'ma19'

/** 편집 컬럼 — 업로드가 받는 컬럼이기도 하다. */
export const PAIR_ORDER_SCHEDULE_EDIT_COLUMNS = [
  { key: 'CLS_DATE', title: '결제일' },
  { key: 'CUT_SEQ', title: '차수' },
  { key: 'CUT_OFF_TIME', title: '마감시각' },
  { key: 'IS_CURRENT', title: '잔여출고확정' },
  { key: 'FST_GI_END', title: '출고예정일' },
  { key: 'LST_GI_END', title: '최종출고일' },
] as const

export type PairOrderScheduleEditKey = (typeof PAIR_ORDER_SCHEDULE_EDIT_COLUMNS)[number]['key']

/** 서버 조회 상한(moms-be MAX_ROW_SIZE)과 같다. */
export const PAIR_ORDER_SCHEDULE_MAX_ROWS = 10_000

/** 한 번의 저장(신규+수정+삭제) 상한 — moms-be ManagePairOrderScheduleService.MAX_SAVE_ROWS 와 같다. 1년치(366일)를 한 번에 올릴 수 있다. */
export const PAIR_ORDER_SCHEDULE_MAX_SAVE_ROWS = 400

/** 조회 기본 기간 — 오늘 기준 앞뒤 일수(생성본 결제일 필드 defaultPeriod 'around15d' 와 같다). */
export const PAIR_ORDER_SCHEDULE_DEFAULT_RANGE_DAYS = 15

/** 업로드 파일 크기 상한(MB). 결제일 하루 한 행이라 10,000행 양식도 1MB 를 넘지 않는다. */
export const PAIR_ORDER_SCHEDULE_UPLOAD_MAX_MB = 5
export const PAIR_ORDER_SCHEDULE_UPLOAD_MAX_BYTES = PAIR_ORDER_SCHEDULE_UPLOAD_MAX_MB * 1000 * 1000

/** 엑셀 다운로드 상세사유 최소 글자 수 — 생성본 사유 모달 okButtonProps(>= 5)와 같다. */
export const PAIR_ORDER_SCHEDULE_DOWNLOAD_DETAIL_MIN_LENGTH = 5
